import { render, staticRenderFns } from "./UpstreamSewageVolume.vue?vue&type=template&id=51577559&"
import script from "./UpstreamSewageVolume.vue?vue&type=script&lang=js&"
export * from "./UpstreamSewageVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports